module.exports = __webpack_public_path__ + "img/female_6.5475e13c.png";